export default class Helpers {
  /**
   * Gera um ID único baseado no timestamp atual e um número aleatório.
   * @param {string} prefix O prefixo a ser adicionado ao ID (opcional).
   * @returns {string} Uma string com o ID gerado.
   */
  static generateUniqueId(prefix: string = 'br'): string {
    const timestamp = Date.now().toString(36) // Data atual na base-36
    const random = Math.random().toString(36).substring(2, 8) // Parte aleatória na base-36
    return `${prefix}-${timestamp}-${random}`
  }

  /**
   * Formata um valor em bytes para uma string legível (KB, MB, GB, etc.).
   * @param {number} bytes O valor em bytes.
   * @param {number} decimals O número de casas decimais (padrão 2).
   * @returns {string} O valor formatado.
   */
  static formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }
}
